import { TrackingStatus } from 'src/types';
import {
  IKameleoonData,
  KameleoonData,
  ApplicationVersionDataType,
} from './types';

/**
 * @class
 * ApplicationVersion - a class for creating an instance for app version
 * */
export class ApplicationVersion implements IKameleoonData {
  public status: TrackingStatus;

  private version: string;

  /**
   * @param {string} version - version of mobile application
   * */
  constructor(version: string) {
    this.version = version;
    this.status = TrackingStatus.Sent;
  }

  get url(): string {
    return '';
  }

  get data(): ApplicationVersionDataType {
    return {
      version: this.version,
      type: KameleoonData.ApplicationVersion,
      status: this.status,
    };
  }
}
